if (!customElements.get('footer-localization')) {
  customElements.define(
    'footer-localization',
    class FooterLocalization extends HTMLElement {
      constructor() {
        super();
        this.dialog = this.querySelector('.c_c-footer-loc-dialog');
        this.openButtons = this.querySelectorAll('.c_js-loc-open');
        this.closeButtons = this.querySelectorAll('.c_js-loc-close');
        this.tabs = this.querySelectorAll('.c_js-loc-tab');
        this.panels = this.querySelectorAll('.c_js-loc-panel');
        this.init();
      }

      init() {
        if (!this.dialog) return;

        this.openButtons.forEach((button) => {
          button.addEventListener('click', () => this.open(button.dataset.locTab));
        });
        this.closeButtons.forEach((button) => {
          button.addEventListener('click', () => this.close());
        });
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.selectTab(tab.dataset.locTab));
        });

        this.dialog.addEventListener('click', (event) => {
          const item = event.target.closest('.c_js-loc-item');
          if (item) {
            this.onSelect(event, item);
            return;
          }
          if (event.target === this.dialog) this.close();
        });
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        });
      }

      open(tab) {
        this.selectTab(tab);
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
      }

      close() {
        // animationend は [open] → is-closing の animation-name 差し替えで発火しないことがあり、
        // ダイアログが開いたままになる。CSS の footer-loc-fade-out と同じ長さを setTimeout で待つ
        this.dialog.classList.add('is-closing');
        setTimeout(() => {
          this.dialog.classList.remove('is-closing');
          this.dialog.close();
          document.body.style.overflow = '';
        }, 250);
      }

      selectTab(tab) {
        if (!tab || !this.tabs.length) return;

        this.tabs.forEach((item) => {
          const active = item.dataset.locTab === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.panels.forEach((panel) => {
          panel.classList.toggle('is-hidden', panel.dataset.locTab !== tab);
        });
      }

      onSelect(event, item) {
        event.preventDefault();
        const form = item.closest('form');
        if (!form) return;

        const input = form.querySelector('input[name="country_code"], input[name="locale_code"]');
        if (input) input.value = item.dataset.value;
        HTMLFormElement.prototype.submit.call(form);
      }
    }
  );
}
